import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

import "./Button.css";

export default function IconButton({
    ref,
    icon,
    label,
    variant = "ghost",
    tone = "neutral",
    size = "sm",
    tooltip = false,
    type = "button",
    className = "",
    ...rest
}) {
    if (!label && import.meta.env.DEV) {
        console.error("IconButton: `label` is required (used as aria-label).");
    }

    const classes = [
        "ui-icon-btn",
        `ui-icon-btn-${variant === "surface" ? "surface" : "ghost"}`,
        `ui-icon-btn-${["xs", "md"].includes(size) ? size : "sm"}`,
        tone === "danger" && "ui-icon-btn-danger",
        className,
    ].filter(Boolean).join(" ");

    const button = (
        <button ref={ref} type={type} className={classes} aria-label={label} {...rest}>
            {icon}
        </button>
    );

    if (!tooltip) return button;

    return (
        <OverlayTrigger placement="bottom" overlay={<Tooltip>{label}</Tooltip>}>
            {button}
        </OverlayTrigger>
    );
}
